<template>
    <div>
      <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
          <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
          <app-navbar></app-navbar>
          <div class="container-fluid mt-5">
            <div class="col-sm-12 print-media">
              <vs-breadcrumb
                align="left"
                :items="
                    [
                      {title: 'You are here : '},
                      {
                        title: 'Reports',
                        url: '/#/dashboard/CountryRepresentative/allReports',
                      },
                      {
                        title: 'Event Brief Report',
                        url: '/#/dashboard/CountryRepresentative/briefTrainingReport',
                        active: true
                      }
                    ]"
              ></vs-breadcrumb>
              <!-- <div class="form-group form-row text-dark">
                <h6 class="sub-frm-title">Event Information</h6>
              </div>-->
            </div>
            <BriefReport />
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import BriefReport from "../../commonPages/BriefTrainingReport";
  import Navbar from "./Navbar";
  import Sidebar from "./Sidebar";
  export default {
    components: {
      "app-navbar": Navbar,
      "app-sidebar": Sidebar,
      BriefReport
    },
    data: () => ({
      isSidebar: false
    })
  };
  </script>
  
  <style scoped>

@media print {
 
  .print-media {
    display: none !important;
  }
}
  </style>